"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSafeAreaEnv = exports.vars = exports.useUnstableNativeVariable = exports.useColorScheme = exports.remapProps = exports.cssInterop = exports.interopComponents = exports.rem = exports.colorScheme = exports.StyleSheet = void 0;
const react_1 = require("react");
const config_1 = require("../config");
const color_scheme_1 = require("./color-scheme");
var stylesheet_1 = require("./stylesheet");
Object.defineProperty(exports, "StyleSheet", { enumerable: true, get: function () { return stylesheet_1.StyleSheet; } });
var color_scheme_2 = require("./color-scheme");
Object.defineProperty(exports, "colorScheme", { enumerable: true, get: function () { return color_scheme_2.colorScheme; } });
var rem_1 = require("./rem");
Object.defineProperty(exports, "rem", { enumerable: true, get: function () { return rem_1.rem; } });
exports.interopComponents = new Map();
const ForwardRefSymbol = Symbol.for("react.forward_ref");
const cssInterop = (baseComponent, mapping) => {
    const configs = (0, config_1.getNormalizeConfig)(mapping);
    const interopComponent = (0, react_1.forwardRef)(function CssInteropComponent({ ...props }, ref) {
        if (props.cssInterop === false) {
            return (0, react_1.createElement)(baseComponent, props);
        }
        props = { ...props, ref };
        for (const config of configs) {
            let newStyles = [];
            const source = props[config.source];
            const target = props[config.target];
            if (typeof source === "string" && source) {
                newStyles.push({
                    $$css: true,
                    [source]: source,
                });
            }
            delete props[config.source];
            if (Array.isArray(target)) {
                newStyles.push(...target);
            }
            else if (target) {
                newStyles.push(target);
            }
            if (newStyles.length > 0) {
                props[config.target] = newStyles;
            }
        }
        if ("$$typeof" in baseComponent &&
            typeof baseComponent === "function" &&
            baseComponent.$$typeof === ForwardRefSymbol) {
            delete props.cssInterop;
            return baseComponent.render(props, props.ref);
        }
        else if (typeof baseComponent === "function" &&
            !(baseComponent.prototype instanceof react_1.Component)) {
            delete props.cssInterop;
            return baseComponent(props);
        }
        else {
            return (0, react_1.createElement)(baseComponent, props);
        }
    });
    interopComponent.displayName = `CssInterop.${baseComponent.displayName ?? baseComponent.name ?? "unknown"}`;
    exports.interopComponents.set(baseComponent, interopComponent);
    return interopComponent;
};
exports.cssInterop = cssInterop;
exports.remapProps = exports.cssInterop;
function useColorScheme() {
    const [effect, setEffect] = (0, react_1.useState)(() => ({
        rerun: () => setEffect((s) => ({ ...s })),
        dependencies: new Set(),
    }));
    return {
        colorScheme: color_scheme_1.colorScheme.get(effect),
        setColorScheme: color_scheme_1.colorScheme.set,
        toggleColorScheme: color_scheme_1.colorScheme.toggle,
    };
}
exports.useColorScheme = useColorScheme;
const useUnstableNativeVariable = (name) => {
    if (process.env.NODE_ENV !== "production") {
        console.log("useUnstableNativeVariable is not supported on web.");
    }
    return undefined;
};
exports.useUnstableNativeVariable = useUnstableNativeVariable;
function vars(variables) {
    const $variables = {};
    for (const [key, value] of Object.entries(variables)) {
        if (key.startsWith("--")) {
            $variables[key] = value.toString();
        }
        else {
            $variables[`--${key}`] = value.toString();
        }
    }
    return $variables;
}
exports.vars = vars;
function useSafeAreaEnv() {
    return undefined;
}
exports.useSafeAreaEnv = useSafeAreaEnv;
//# sourceMappingURL=api.js.map